import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { WindowDays } from "@/lib/github/types";
import { WINDOW_DAYS_OPTIONS } from "@/lib/github/queries";

interface DateRangePickerProps {
  value: WindowDays;
  onChange: (value: WindowDays) => void;
}

export function DateRangePicker({ value, onChange }: DateRangePickerProps) {
  function handleValueChange(raw: string) {
    onChange(Number(raw) as WindowDays);
  }

  return (
    <div className="flex items-center gap-2">
      <Label htmlFor="date-range-select" className="text-sm select-none whitespace-nowrap">
        Window
      </Label>
      <Select value={String(value)} onValueChange={handleValueChange}>
        <SelectTrigger
          id="date-range-select"
          aria-label="Date range"
          className="w-[140px] h-8 text-sm"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {WINDOW_DAYS_OPTIONS.map((days) => (
            <SelectItem key={days} value={String(days)}>
              Last {days} days
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
